/*
 * @Author: liujunhong
 * @Date: 2023/2/14
 * @Desc: 页面错误提示
 */

import React, { FC, ReactNode } from 'react';
import styles from './style.module.less';

interface Props {
  content: string | ReactNode;
  id?: string;
}

const Index: FC<Props> = props => {
  const {content, id} = props;
  return <div className={styles.error_tips_wrap}>
    <i className={styles.error_tips_icon}></i>
    <div id={id}>
      {content}
    </div>

  </div>;
};
export default Index;
